// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

// THIS FILE WAS AUTOGENERATED

/**
 * The abstract common base of all domains.
 */
export class Domain {

    constructor() {
    }
}
